import SideBar from "../../components/navigation/SideBar";
import BasicActions from "../../components/headings/BasicActions";
import TableCard from "../../components/tables/TableCard";
import { NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { useFetchCoachsQuery, useDeleteCoachMutation } from "../../store";
import ConfirmDeleteModal from "../../components/modals/ConfirmDeleteModal";

function Coaches(){
  const navigate = useNavigate();
  const [deleteCoach] = useDeleteCoachMutation();
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [selectedCoach, setSelectedCoach] = useState(null);

  const handleDeleteClick = (coach) => {
    setSelectedCoach(coach);
    setConfirmOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (!selectedCoach) return;
    try {
      await deleteCoach(selectedCoach.id).unwrap();
    } catch (err) {
      console.error("Error deleting coach:", err);
      alert("No se pudo eliminar el coach. Inténtalo de nuevo.");
    } finally {
      setSelectedCoach(null);
    }
  };

  const config = [
    {
      key: 'Id',
      label: 'Id',
      render: (coach) => coach.id,
      rowClassname: 'whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6',
      columnClassname: 'py-3.5 pl-4 pr-3 text-left text-sm font-semibold text-gray-900 sm:pl-6',
    },
    {
      key: 'name',
      label: 'Name',
      render: (coach) => coach.name,
      rowClassname: 'whitespace-nowrap px-3 py-4 text-sm text-gray-500',
      columnClassname: 'px-3 py-3.5 text-left text-sm font-semibold text-gray-900',
    },
    {
      key: 'email',
      label: 'Email',
      render: (coach) => coach.email,
      rowClassname: 'whitespace-nowrap px-3 py-4 text-sm text-gray-500',
      columnClassname: 'px-3 py-3.5 text-left text-sm font-semibold text-gray-900',
    },
    {
      key: 'role',
      label: 'Role',
      render: (coach) => coach.role,
      rowClassname: 'whitespace-nowrap px-3 py-4 text-sm text-gray-500',
      columnClassname: 'px-3 py-3.5 text-left text-sm font-semibold text-gray-900',
    },
    {
      key: 'Active',
      label: 'Active',
      render: (coach) => coach.active ? 'Active': 'Inactive',
      rowClassname: 'whitespace-nowrap px-3 py-4 text-sm text-gray-500',
      columnClassname: 'px-3 py-3.5 text-left text-sm font-semibold text-gray-900',
    },
    {
      key: 'Edit',
      label: '',
      render: (coach) => <NavLink to={`/coach/${coach.id}`} className="text-indigo-600 hover:text-indigo-900">
        Edit<span className="sr-only">, {coach.name}</span>
        </NavLink>,
      rowClassname: 'relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6',
      columnClassname: 'px-3 py-3.5 text-left text-sm font-semibold text-gray-900',
    },
    {
      key: 'Delete',
      label: '',
      render: (coach) => (
        <button
          type="button"
          onClick={() => handleDeleteClick(coach)}
          className="text-red-600 hover:text-red-900"
        >
          Delete<span className="sr-only">, {coach.name}</span>
        </button>
      ),
      rowClassname: 'relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6',
      columnClassname: 'px-3 py-3.5 text-left text-sm font-semibold text-gray-900',
    },
  ];

  const handleNew = (event)=>{
    event.preventDefault();
    navigate("/coach/create");
  }

  const actions = [
    {label: 'New', onClick:handleNew, class: 'primary'},
  ]

  const keyFn = (coach) => {
    return coach.id;
  };

  const { data, error, isLoading} = useFetchCoachsQuery();
  let table;
  if (isLoading){
    table = <div> Loading</div>
  } else if (error){
    table = <div> Errors</div>
  } else {
    table = <TableCard data={data} config={config} keyFn={keyFn} />;
  }
  return (
    <>
    <div>
      <SideBar/>
      <main className="py-10 lg:pl-72">
        <div className="px-4 sm:px-6 lg:px-8">
          <BasicActions object="Coaches" actions={actions}/>
          {table}
        </div>
      </main>
    </div>
    <ConfirmDeleteModal
      isOpen={confirmOpen}
      setIsOpen={setConfirmOpen}
      onConfirm={handleConfirmDelete}
      title="Delete coach"
      confirmLabel="Delete coach"
      message={
        selectedCoach
          ? `Delete coach «${selectedCoach.name || selectedCoach.email}»?\n\n` +
            `Their athletes, exercises, programs and workouts will be left without a coach (unassigned), ` +
            `and their knowledge-base entries will be deleted. This cannot be undone.`
          : ''
      }
    />
    </>
  );
}

export default Coaches;
